import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SortPart1gsioxz0aa07v as SortPart } from './SortPart.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SortBuilderClass;
function SortBuilder() {
  if (SortBuilderClass === VOID) {
    class $ {
      constructor() {
        this.k4a_1 = ArrayList().w();
      }
      l4a(sort) {
        this.k4a_1.v(sort);
      }
      o1r() {
        return toList(this.k4a_1);
      }
      m4a(_this__u8e3s4) {
        return this.l4a(new (SortPart())(_this__u8e3s4, true));
      }
      n4a(_this__u8e3s4) {
        return this.l4a(new (SortPart())(_this__u8e3s4, false));
      }
      o4a(_this__u8e3s4) {
        return this.l4a(new (SortPart())(_this__u8e3s4, true));
      }
    }
    initMetadataForClass($, 'SortBuilder', SortBuilder);
    SortBuilderClass = $;
  }
  return SortBuilderClass;
}
//region block: exports
export {
  SortBuilder as SortBuilder2qc3a7b1bw9uz,
};
//endregion

//# sourceMappingURL=SortBuilder.mjs.map
